// @core/api/endpoints/payment/get_payment_method.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetPaymentMethodResponse,
} from '../../../types/payment';

const BASE_PATH = '/payment';

/**
 * Get payment method by ID
 * Retrieves payment method by the specified identifier.
 */
export async function GetPaymentMethod(
  id: string,
  options?: RequestOptions
): Promise<GetPaymentMethodResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/payment-methods/:id`;
  requestPath = requestPath.replace(':id', encodeURIComponent(id));
  const requestOptions = options;
  return client.get<GetPaymentMethodResponse>(requestPath, { ...requestOptions });
}
